document.addEventListener(
    "invalid",
    (event) => {
        const target = event.target;

        if (!(target instanceof HTMLInputElement)) return;

        target.setCustomValidity(target.dataset.invalidMessage ?? "");
    },
    true,
);

["input", "change"].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
        const target = event.target;

        if (!(target instanceof HTMLInputElement)) return;

        target.setCustomValidity("");
    });
});

document.querySelectorAll(".address-form input").forEach((input) => {
    input.addEventListener("input", () => {
        const saveAddress = document.querySelector(".save-address");

        if (/** @type {HTMLInputElement} */ (input).checkValidity()) {
            saveAddress?.classList.remove("disabled");
            input
                .closest(".form-group")
                ?.querySelector(".pattern-error")
                ?.classList.add("d-none");
        } else {
            saveAddress?.classList.add("disabled");
        }
    });
});

// @todo One-way reveal: there is no matching branch that re-hides `.pattern-error`
// once the value becomes valid again. Inside an `.address-form` the other two
// handlers below/above do hide it, so this only strands an error message on a
// standalone `.input-pattern`.
document.querySelectorAll(".input-pattern").forEach((input) => {
    input.addEventListener("change", () => {
        if (!(/** @type {HTMLInputElement} */ (input).checkValidity())) {
            input
                .closest(".form-group")
                ?.querySelector(".pattern-error")
                ?.classList.remove("d-none");
        }
    });
});

document.querySelectorAll(".input-pattern-red").forEach((input) => {
    input.addEventListener("change", () => {
        if (!(/** @type {HTMLInputElement} */ (input).checkValidity())) {
            input
                .closest(".form-group")
                ?.querySelector(".lux-disclaimer .text-luxplus")
                ?.classList.remove("text-luxplus");
        }
    });
});

/**
 * Check whether a string contains at least one uppercase letter.
 *
 * @param {string} str - The string to test.
 * @returns {boolean} True if the string contains an uppercase letter.
 */
function containsUppercase(str) {
    const uppercasePattern = /\p{Lu}/u;
    return uppercasePattern.test(str);
}

/**
 * Check whether a string contains at least one lowercase letter.
 *
 * @param {string} str - The string to test.
 * @returns {boolean} True if the string contains a lowercase letter.
 */
function containsLowercase(str) {
    const lowercasePattern = /\p{Ll}/u;
    return lowercasePattern.test(str);
}

/**
 * Check whether a string contains at least one digit.
 *
 * @param {string} str - The string to test.
 * @returns {boolean} True if the string contains a digit.
 */
function containsNumber(str) {
    return /[0-9]/.test(str);
}

document.querySelectorAll(".password-check-validity").forEach((input) => {
    input.addEventListener("input", () => {
        const inputValue = /** @type {HTMLInputElement} */ (input).value;

        document
            .querySelector(".password-length")
            ?.classList.toggle("accepted", inputValue.length >= 8);
        document
            .querySelector(".password-uppercase")
            ?.classList.toggle("accepted", containsUppercase(inputValue));
        document
            .querySelector(".password-lowercase")
            ?.classList.toggle("accepted", containsLowercase(inputValue));
        document
            .querySelector(".password-number")
            ?.classList.toggle("accepted", containsNumber(inputValue));
    });
});

const validation = {
    /**
     * Toggle password input visibility between text and password type.
     *
     * @param {Element} e - The toggle button element inside a password wrapper.
     * @returns {void}
     */
    showPassword(e) {
        var passwordInput = /** @type {HTMLElement} */ (e)
            .closest(".lux-password-wrapper")
            ?.querySelector("input");

        if (!passwordInput) return;

        if (passwordInput.getAttribute("type") === "password") {
            passwordInput.setAttribute("type", "text");
            e.classList.add("active");
        } else {
            passwordInput.setAttribute("type", "password");
            e.classList.remove("active");
        }
    },
    /**
     * Check HTML5 pattern validity and toggle the save-address button state.
     *
     * @param {HTMLInputElement} input - The input element to validate.
     * @returns {void}
     */
    checkPattern(input) {
        const saveAddress = document.querySelector(".save-address");

        if (!saveAddress) return;

        if (input.checkValidity()) {
            saveAddress.classList.remove("disabled");
            saveAddress.removeAttribute("disabled");

            const patternError = input
                .closest(".form-group")
                ?.querySelector(".pattern-error");
            if (patternError) {
                patternError.classList.add("d-none");
            }
        } else {
            saveAddress.classList.add("disabled");
            saveAddress.setAttribute("disabled", "");
        }
    },
};
window.validation = validation;

document.addEventListener("click", (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const toggle = target.closest(".show-password-toggle");

    if (toggle instanceof HTMLElement) {
        validation.showPassword(toggle);
    }
});

document.querySelectorAll(".address-form").forEach(function (form) {
    const saveAddress = form.querySelector(".save-address");

    if (saveAddress) {
        saveAddress.addEventListener("click", function () {
            const inputs = form.querySelectorAll(
                "input[pattern], input[required]",
            );

            inputs.forEach((input) => {
                const errorContainer = input
                    .closest(".form-group")
                    ?.querySelector(".pattern-error");

                if (
                    !(/** @type {HTMLInputElement} */ (input).checkValidity())
                ) {
                    input.classList.add("is-invalid");
                    if (errorContainer) {
                        errorContainer.classList.remove("d-none");
                    }
                } else {
                    input.classList.remove("is-invalid");
                    if (errorContainer) {
                        errorContainer.classList.add("d-none");
                    }
                }
            });
        });
    }
});

if (import.meta.hot) {
    import.meta.hot.accept();
}

export {};
